import e from "../../utils/esm/generateUtilityClasses/generateUtilityClasses.js";
const l = e("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]);
export {
  l as default
};
